import PropTypes from "prop-types";
import classNames from "classnames";
import {
  WALLET_TRANSACTION_ACTION,
  WALLET_TRANSACTION_ACTION_MAP,
} from "../../../../../../constants/wallet";
import WalletTransactionIcon from "./WalletTransactionIcon/WalletTransactionIcon";
import classes from "./WalletTransactionListItem.module.css";

const WalletTransactionListItem = (props) => {
  const {
    transaction: { value, action },
  } = props;

  return (
    <li
      className={classNames(
        classes["wallet-transaction-list-item"],
        {
          [classes["wallet-transaction-list-item--deduction"]]:
            WALLET_TRANSACTION_ACTION.ORDER_ITEM_WALLET_DEDUCTION === action,
        },
        {
          [classes["wallet-transaction-list-item--topup"]]:
            WALLET_TRANSACTION_ACTION.MECHANIC_TOPUP === action,
        }
      )}
    >
      <WalletTransactionIcon action={action} />
      <p className={classes["wallet-transaction-list-item__text"]}>
        {WALLET_TRANSACTION_ACTION_MAP.get(action)}
      </p>
      <p className={classes["wallet-transaction-list-item__value-wrapper"]}>
        <span
          className={classNames(
            classes["wallet-transaction-list-item__value"],
            "numeric-content"
          )}
        >
          {value}
        </span>
        <span className={classes["wallet-transaction-list-item__currency"]}>
          جنيه
        </span>
      </p>
    </li>
  );
};

export default WalletTransactionListItem;

WalletTransactionListItem.propTypes = {
  transaction: PropTypes.object,
};
